import React from 'react';
import RegisterForm from '../../components/auth/RegisterForm';
import { Container, Typography, Box } from '@mui/material';
import authService, { RegisterData } from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const Register: React.FC = () => {
  const navigate = useNavigate();

  const handleRegister = async (data: RegisterData) => {
    try {
      // Call the register method from authService
      const response = await authService.register(data);
      
      // If registration is successful, redirect to login page
      if (response && response.user) {
        // Wait a moment to show success message before redirecting
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
      
      return response;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  };

  return (
    <Container>
      <Box sx={{ mt: 4, mb: 2 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Đăng ký tài khoản
        </Typography>
        <Typography variant="body1" align="center" color="text.secondary" paragraph>
          Tham gia nền tảng của chúng tôi để tạo câu hỏi từ tài liệu của bạn
        </Typography>
      </Box>
      <RegisterForm onSubmit={handleRegister} />
    </Container>
  );
};

export default Register; 